import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LogoutTipComponent } from './logout-tip.component';

@NgModule({
    imports: [
        CommonModule,
    ],
    exports: [LogoutTipComponent],
    declarations: [LogoutTipComponent],
})
export class LogoutTipModule { }
